module.exports = __webpack_public_path__ + "static/media/api_url.84808f46.svg";